import React, { useEffect, useState } from "react";
import { useLocation } from "react-router";
import LoadingSpin from "../../loadingSpin/LoadingSpin";
import {
  Card,
  Col,
  Divider,
  Row,
  Table,
  Typography,
  Tag,
} from "antd";
import { ArrowLeftOutlined } from "@ant-design/icons";

import GetBinService from "../../../services/Wash-service/GetBinService";
import garment_img from "../../../assets/dashboard/garment_img.png";
import ResponseMessage from "../../Comman/Notification/ResponseMessge";
import "../../../styles/global-ui.css";

const { Title, Text } = Typography;

const BinTransitKanbanView = ({ handleArrowClick }) => {
  const location = useLocation();

  const [binId, setBinId] = useState();
  const [isLoading, setIsLoading] = useState(false);
  const [displayGarment, setDisplayGarment] = useState([]);

  useEffect(() => {
    const fetchKanbanData = async () => {
      const queryParams = new URLSearchParams(location.search);
      const currentBinId = queryParams.get("binId");

      setBinId(currentBinId);

      if (!currentBinId) {
        ResponseMessage.error({ message: "No Bin ID provided." });
        return;
      }

      setIsLoading(true);
      try {
        const response = await GetBinService.ViewBinbyId(currentBinId);

        if (Array.isArray(response?.data) && response.data.length > 0) {
          setDisplayGarment(response.data);
        } else {
          ResponseMessage.warning({
            message: response?.message || "No Bin data available.",
          });
          handleArrowClick();
        }
      } catch (error) {
        console.error(error);
        ResponseMessage.error({
          message: "An error occurred while fetching data.",
        });
        handleArrowClick();
      } finally {
        setIsLoading(false);
      }
    };

    fetchKanbanData();
  }, [location, handleArrowClick]);

  const aggregatedSizes = displayGarment.reduce((acc, garment) => {
    const sizeData = JSON.parse(garment.size_qty || "{}");
    Object.keys(sizeData).forEach((size) => {
      const qty = Number(sizeData[size]);
      if (qty > 0) {
        acc[size] = (acc[size] || 0) + qty;
      }
    });
    return acc;
  }, {});

  const totalQuantity = Object.values(aggregatedSizes).reduce(
    (sum, qty) => sum + qty,
    0
  );

  return (
    <div className="page-container">
      <style>
        {`
          .info-container {
            display: flex;
            flex-direction: column;
            gap: 8px;
            margin-top: 10px;
          }

          .info-row {
            display: flex;
            justify-content: space-between;
            align-items: center;
            background: #f8fafc;
            padding: 10px 12px;
            border-radius: 10px;
            border: 1px solid #e2e8f0;
            gap: 12px;
          }

          .info-label {
            color: #64748b;
            font-weight: 500;
            font-size: 13px;
            min-width: 70px;
          }

          .info-value {
            color: #0f172a;
            font-weight: 700;
            font-size: 14px;
            text-align: right;
            word-break: break-word;
          }

          .garment-image-wrap {
            text-align: center;
            margin-bottom: 14px;
          }

          .garment-image {
            width: 120px;
            max-width: 100%;
            object-fit: contain;
          }

          .garment-size-table .ant-table-thead > tr > th {
            background: linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%);
            color: #475569;
            font-weight: 600;
          }

          .summary-size-wrap {
            display: flex;
            flex-wrap: wrap;
            gap: 12px;
          }

          .summary-size-pill {
            background: #f8fafc;
            border: 1px solid #e2e8f0;
            border-radius: 10px;
            padding: 8px 14px;
            font-size: 14px;
            color: #334155;
            font-weight: 600;
          }
        `}
      </style>

      <div className="page-header">
        <div className="page-title-wrap">
          <Title level={3} className="page-title">
            <ArrowLeftOutlined
              onClick={handleArrowClick}
              style={{ marginRight: 10, cursor: "pointer" }}
            />
            Bin {binId}
          </Title>
          <Text className="page-subtitle">
            In-transit bin garment details
          </Text>
        </div>

        <Tag className="filter-tag" color="blue">
          Total Quantity: {totalQuantity}
        </Tag>
      </div>

      <Divider className="page-divider" />

      {isLoading ? (
        <div className="dashboard-loading-wrap">
          <LoadingSpin />
        </div>
      ) : (
        <>
          <Card
            className="modern-card"
            style={{ marginBottom: 24 }}
            title="Size Summary"
          >
            <div className="summary-size-wrap">
              {Object.entries(aggregatedSizes).map(([size, qty]) => (
                <div key={size} className="summary-size-pill">
                  {size}: {qty}
                </div>
              ))}
            </div>
          </Card>

          {displayGarment.length > 0 ? (
            <Row gutter={[16, 16]}>
              {displayGarment.map((garment) => {
                const sizeData = JSON.parse(garment.size_qty || "{}");

                const filteredSizeData = Object.keys(sizeData)
                  .filter((size) => sizeData[size] && Number(sizeData[size]) > 0)
                  .reduce((acc, size) => {
                    acc[size] = sizeData[size];
                    return acc;
                  }, {});

                const sizeColumns = Object.keys(filteredSizeData).map((size) => ({
                  title: size,
                  dataIndex: size,
                  key: size,
                  align: "center",
                  render: (text) => <strong>{text}</strong>,
                }));

                return (
                  <Col xs={24} sm={12} lg={8} key={garment.dbd_id}>
                    <Card
                      className="modern-card"
                      title={
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                            gap: 12,
                          }}
                        >
                          <span>Kanban</span>
                          <strong style={{ color: "#7c3aed" }}>
                            {garment.kanban_no}
                          </strong>
                        </div>
                      }
                    >
                      <div className="garment-image-wrap">
                        <img
                          src={garment_img}
                          alt="Garment"
                          className="garment-image"
                        />
                      </div>

                      <div className="info-container">
                        <div className="info-row">
                          <span className="info-label">Item</span>
                          <span className="info-value">{garment.item_no}</span>
                        </div>

                        <div className="info-row">
                          <span className="info-label">PO</span>
                          <span className="info-value">{garment.po_no}</span>
                        </div>

                        <div className="info-row">
                          <span className="info-label">Country</span>
                          <span className="info-value">
                            {garment.country || "N/A"}
                          </span>
                        </div>

                        <div className="info-row">
                          <span className="info-label">Qty</span>
                          <span className="info-value">{garment.total_qty}</span>
                        </div>

                        <div className="info-row">
                          <span className="info-label">Color</span>
                          <span className="info-value">{garment.color}</span>
                        </div>
                      </div>

                      <Table
                        size="small"
                        columns={sizeColumns}
                        dataSource={[filteredSizeData]}
                        pagination={false}
                        style={{ marginTop: 14 }}
                        className="garment-size-table"
                        rowKey={() => garment.dbd_id}
                      />
                    </Card>
                  </Col>
                );
              })}
            </Row>
          ) : (
            <div className="dashboard-loading-wrap">
              <Text type="secondary">No data found</Text>
            </div>
          )}
        </>
      )}
    </div>
  );
};

export default BinTransitKanbanView;